import React from 'react';
import ReactDom from 'react-dom';
import Container from './components/Container/index-pc';
import NuContainer from './components/Container/nu-index-pc';
import Styles from './index-pc.module.scss';
import { IFatigue, trigger, Fatigue, deepCopy } from './utils';
import { getNuPopupJumpLand } from './server/request';
interface SubscribeParam {
  site: string;
  itemList: string;
  tenant: string;
}
export enum POPUP_TYPE {
  PROMOTION = 'PROMOTION',
  SUBSCRIPTION = 'SUBSCRIPTION',
  NU_VOUCHER = 'NU_VOUCHER',
  PROMOTION_IMAGE = 'PROMOTION_IMAGE',
}
export interface ShowConfig {
  data: {
    title: string;
    explanation: string;
    headerImageUrl: string;
    backgroundColor: string;
    closeImageUrl: string;
    btnText?: string;
    indication?: string;
    email?: string;
    subscribeParam?: SubscribeParam;
    type: POPUP_TYPE;
    targetUrl: string;
    successToast: string;
    failureToast: string;
    closeBtnText: string;
    tc?: string;
    imageUrl?: string;
    voucher?: { [key: string]: any };
    howToUse?: string;
  };
  userTrack?: {
    spmd?: string;
    exposeArgs?: object;
    trackingParam?: object;
    clickArgs?: object;
    spmc?: string;
  };
}
export interface Trigger {
  duration?: string;
  scroll?: string;
}

class SubscribePopup {
  private static registered: boolean = false;
  private static root: HTMLDivElement = null;
  private static containerRef: React.MutableRefObject<HTMLDivElement> = null;
  private static createRoot() {
    this.root = document.createElement('div');
    this.root.style.position = 'fixed';
    this.root.style.zIndex = '199';
    this.root.style.width = '100vw';
    this.root.style.overflow = 'hidden';
    this.root.style.left = '0';
    this.root.style.top = '0';
    this.root.style.backgroundColor = 'rgba(0,0,0,.6)';
    this.root.onclick = (e) => {
      if (e.target === this.root) {
        this.close();
      }
    };
    document.body.appendChild(this.root);
  }

  private static showRoot() {
    this.root.style.height = '100vh';

    // 禁止 popup 下方滚动
    document.body.style.overflow = 'hidden';
  }

  static show(props: ShowConfig) {
    const { type } = props.data;
    this.registered = false;
    if (!this.root) {
      this.createRoot();
    }
    this.showRoot();
    this.containerRef = React.createRef<HTMLDivElement>();
    let Dom;
    if (type === POPUP_TYPE.NU_VOUCHER) {
      console.log(type, 'type', NuContainer);
      Dom = NuContainer;
    } else {
      Dom = Container;
    }
    ReactDom.render(<Dom {...props} ref={this.containerRef} />, this.root);
  }

  static close() {
    if (!this.root) {
      return;
    }
    this.containerRef.current.classList.add(Styles.container_transition);
    this.containerRef.current.style.height = '0';
    setTimeout(() => {
      ReactDom.unmountComponentAtNode(this.root);
      this.root.style.height = '0';
      document.body.style.overflow = '';
      this.containerRef = null;
    }, 250);
  }

  static registerPopup(
    config: ShowConfig,
    triggerConfig: Trigger,
    fatigueConfig: IFatigue
  ) {
    const popUpData = getNuPopupJumpLand();
    switch (!!popUpData) {
      case true:
        this.show(JSON.parse(popUpData));
        break;

      default:
        Fatigue(
          deepCopy(
            Object.assign(fatigueConfig, {
              type: config.data.type,
            })
          ),
          (show) => {
            if (show) {
              trigger({
                scroll: Number(triggerConfig.scroll),
                duration: Number(triggerConfig.duration),
                callback: () => {
                  this.registered && this.show(config);
                },
              });
              this.registered = true;
            }
          }
        );
        break;
    }
  }

  private constructor() {
    throw new Error('Instantiating SubscribePopup is not allowed');
  }
}

export default SubscribePopup;
